import { Skeleton } from '@/components/ui/skeleton';
import { PageHeaderSkeleton } from './PageHeaderSkeleton';
import { CardGridSkeleton } from './CardGridSkeleton';
import { PageWrapper } from '@/components/layout';

/**
 * Skeleton for the Dashboard page (authenticated users).
 * Reserves ~630px total height to prevent CLS.
 *
 * Layout breakdown:
 * - PageHeader with gradient: ~130px
 * - Tabs: ~40px
 * - Progress bar section: ~40px
 * - Filter bar: ~120px
 * - Card grid (6 cards): ~300px
 */
export function DashboardPageSkeleton() {
  return (
    <PageWrapper
      header={<PageHeaderSkeleton variant="gradient" showDescription={true} showActions={true} />}
    >
      <div className="pt-6 pb-12">
        {/* Tabs */}
        <div className="grid w-full grid-cols-4 gap-1 bg-muted p-1 rounded-lg mb-6">
          <Skeleton className="h-9 rounded-md" />
          <Skeleton className="h-9 rounded-md" />
          <Skeleton className="h-9 rounded-md" />
          <Skeleton className="h-9 rounded-md" />
        </div>

        {/* Progress Bar Section */}
        <div className="mb-6">
          <div className="flex items-center gap-4 mb-2">
            <Skeleton className="h-2 flex-1" />
            <Skeleton className="h-4 w-20" />
          </div>
        </div>

        {/* Filter Bar */}
        <div className="mb-6 flex flex-col gap-3">
          {/* Search */}
          <Skeleton className="h-10 w-full sm:max-w-md" />

          {/* Filters Row */}
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2">
              <Skeleton className="h-10 w-[130px]" />
              <Skeleton className="h-10 w-[120px]" />
            </div>
            {/* View Mode Toggle */}
            <div className="flex rounded-lg border border-border p-1 gap-1">
              <Skeleton className="h-8 w-8" />
              <Skeleton className="h-8 w-8" />
            </div>
          </div>
        </div>

        {/* Bills Grid */}
        <CardGridSkeleton count={6} />
      </div>
    </PageWrapper>
  );
}
